export { default as ModuleSwitcher } from './components/ModuleSwitcher';
export { onModuleClick } from './actions/onModuleClick';
